export enum SoilType {
  Mineral = 'Mineral',
  Organic = 'Organic'
}
